module.exports = __webpack_public_path__ + "media/icons/phone-b20fb0ca.png";